import React from "react";

export default function EllipseIcon(props) {
  return (
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="10.5" cy="10.5" r="9.5" fill="white" stroke="#2B569F" strokeWidth={2} />
      <circle cx="10.5" cy="10.5" r="6.5" fill="#2B569F" />
      <circle cx="10.5" cy="10.5" r="6.5" stroke="#DEE2E8" />
    </svg>
  );
}
